import React from "react";

// librabry config 
// import "./style.css";

const CPKYC = () => {
  return (
    <iframe
      src={`${process.env.PUBLIC_URL}/Cpkyc.html`}
      title="KYC Form"
      width="100%"
      height="1000px"
      style={{ border: "none" }}
    />
  );
};

export default CPKYC;
